import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { modalOpen, modalClose } from '../../actions/modals';
// import { modalRouter } from '../../router';
import invariant from "invariant";
import { Button } from 'reactstrap';

const mapStateToProps = state => ({  });

const matchDispatchToProps = dispatch => {
  return bindActionCreators({ modalClose, modalOpen }, dispatch);
};

const isModifiedEvent = event =>
  !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);

class ModalLink extends Component {

  handleClick (event) {
    if (this.props.onClick)
      this.props.onClick(event);
    
    if (
      !event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !isModifiedEvent(event) // ignore clicks with modifier keys
    ) {
      event.preventDefault();
      
      const { to, params, modalOpen } = this.props;
      modalOpen(to, params);
    }
  };
  
  render() {
    const { to, params, className, children, color, size, style, outline } = this.props; // eslint-disable-line no-unused-vars
    
    invariant(to !== undefined, 'You must specify the "to" property');
    
    return (
      <Button color={color || "link"} {...{className, size, style, outline}} onClick={this.handleClick.bind(this)}>{ children }</Button>
    );
  }
}

export default connect(mapStateToProps, matchDispatchToProps)(ModalLink);


// WEBPACK FOOTER //
// ./src/components/modals/ModalLink.js